exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".name-builder svg{width:30px;height:30px;margin:0 -3px}@media (min-width:768px){.name-builder svg{width:auto;height:auto;margin:0}}.name-builder .letter-space{width:30px}@media (min-width:768px){.name-builder .letter-space{width:50px}}", ""]);

// exports
